import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import logo from '../../../assets/static/images/logo.png';
import doctor_black from '../../../assets/static/images/user-doctor-b.svg';
import doctor_gray from '../../../assets/static/images/user-doctor-g.svg';
import patient_black from '../../../assets/static/images/user-patient-b.svg';
import patient_gray from '../../../assets/static/images/user-patient-g.svg';
import { defaultImage } from '../../../itrust_common/components/HelperFunctions';
import { organisationLoad, organisationValidate } from '../../../redux/actions/public/OrganisationActions';
import { setAccountType } from '../../../itrust_common/redux/actions/authActions';
import nonExistingUrlImg from '../../../assets/static/images/non_existing_url.jpg';
import nonExistingUrlImgTab from '../../../assets/static/images/non_existing_url_tab.png';

let AccountType = ({ accountType, organisation, dispatch, isOrgNotExist }) => {

  const handleAccountType = (type) => {
    dispatch(setAccountType(type))
  }

  useEffect(()=>{
    dispatch(organisationLoad())
    dispatch(organisationValidate())
  },[])

  return(
    <div className={`bg-light h-100 ${!isOrgNotExist && 'container' }`}>
      <Helmet>
        <title>{organisation.name}</title>
        <link rel="shortcut icon" href={organisation.logo_attributes ? organisation.logo_attributes.file.url : logo} sizes="16x16" />
      </Helmet>
      {isOrgNotExist ? <picture>
        <source media="(max-width: 800px)" srcSet={nonExistingUrlImgTab} type="image/png" />
        <img src={nonExistingUrlImg} alt='Non Existing URL Image' className='w-100 h-100' />
      </picture> :
          <>
            <div className="text-center my-auto">
              {
                organisation.logo_attributes ? <img src={defaultImage(organisation.logo_attributes)} alt="logo" className="org-logo-login border-0 mb-9" /> : <p className="store-logo-text py-10 mx-auto"><span className="bg-white p-4">{organisation.name}</span></p>
              }
            </div>
            <div className="text-center">
              <h3 className="pb-7">Choose Account Type</h3>
            </div>
            <div className="d-flex justify-content-center my-9">

              <div className="text-center w-100 mx-6" style={{ maxWidth: "20rem", maxHeight: "20rem" }}>
                <div className={`text-center shadow bg-white rounded h-100 ${accountType === "doctor" && 'border border-primary'} pb-9 mb-5`} onClick={() => handleAccountType("doctor")}>
                  <h6 className="text-muted py-6">Doctor</h6>
                  <img src={accountType === "doctor" ? doctor_black : doctor_gray} className="img-fluid" style={{ maxWidth: "11rem" }} alt="doctor"></img>
                </div>
                {accountType === "doctor" && <span className="badge bg-primary-light rounded-circle"><i className="la la-check-circle text-primary p-2"></i></span>}
              </div>
              <div className="text-center w-100 mx-6" style={{ maxWidth: "20rem", maxHeight: "20rem" }}>
                <div className={`text-center shadow bg-white rounded h-100 ${accountType === "patient" && 'border border-primary'} pb-9 mb-5`} onClick={() => handleAccountType("patient")}>
                  <h6 className="text-muted py-6">Patient</h6>
                  <img src={accountType === "patient" ? patient_black : patient_gray} className="img-fluid" style={{ maxWidth: "16rem" }} alt="doctor"></img>
                </div>
                {accountType === "patient" && <span className="badge bg-primary-light rounded-circle"><i className="la la-check-circle text-primary p-2"></i></span>}
              </div>
            </div>
            <div className="text-center">
              <Link to={`/${accountType}/sign-in`} className="btn btn-primary mt-7">Continue to login</Link>
            </div>
            <div className="footer mx-auto fixed-bottom text-dark pb-6 w-100 text-center">
              <span>&copy; Copyright {new Date().getFullYear()} iTrust.io LLC. All rights reserved.</span>
            </div>
          </>
      }
    </div>
  );
}

const mapStateToProps = store => {
  const { auth, publicOrganisation} = store
  return {
    accountType: auth.accountType,
    currentUser: auth.user,
    organisation: publicOrganisation.current_organisation,
    isOrgNotExist: publicOrganisation.isOrgNotExist
  };
};

export default connect(mapStateToProps)(AccountType);